import type { ReactNode } from "react";
import styles from "./forms/Form.module.css";

type FormFooterProps = {
  children: ReactNode;
};

export function FormFooter({ children }: FormFooterProps) {
  return <div className={styles.modalFooter}>{children}</div>;
}
